// general
require('react')
require('react-dom')
require('redux')
require('react-redux')
require('create-react-class')
require('redux-optimist')
require('redux-thunk')
require('url-pattern')
require('classnames')
require('reselect')
require('hammerjs')
require('socketcluster-client')
require('idb-keyval')
require('whatwg-fetch')
require('react-sortable-hoc')
require('react-dropzone')
require('react-hover-observer')
require('moment')
require('webfontloader')

// ui
require('./ui')

// kb
require('fuse.js')
require('recompose')
require('filestack-js')
require('react-color')

require('@tinymce/tinymce-react')
require('tinymce/tinymce')
require('tinymce/themes/modern/theme')
require('tinymce/plugins/link/plugin')
require('tinymce/plugins/image/plugin')
require('tinymce/plugins/code/plugin')
require('tinymce/plugins/lists/plugin')
require('tinymce/plugins/paste/plugin')
require('tinymce/plugins/autolink/plugin')

// prism
require('prismjs')
// These are required for other languages and must be in the order:
require('prismjs/components/prism-core.min')
require('prismjs/components/prism-markup.min')
require('prismjs/components/prism-markup-templating.min')
require('prismjs/components/prism-css.min')
require('prismjs/components/prism-clike.min')

// All other supported languages
require('prismjs/components/prism-javascript.min')
require('prismjs/components/prism-java.min')
require('prismjs/components/prism-markdown.min')
require('prismjs/components/prism-jsx.min')
require('prismjs/components/prism-tsx.min')
require('prismjs/components/prism-typescript.min')
require('prismjs/components/prism-bash.min')
require('prismjs/components/prism-c.min')
require('prismjs/components/prism-csharp.min')
require('prismjs/components/prism-cpp.min')
require('prismjs/components/prism-objectivec.min')
require('prismjs/components/prism-php.min')
require('prismjs/components/prism-python.min')
require('prismjs/components/prism-ruby.min')
require('prismjs/components/prism-swift.min')
